'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'TaxRestService',
    function($modal, TaxRestService) {
        return {
            select: select,
            create: create,
            edit: edit,
            api: TaxRestService,
        };

        function select(tax, filters, def) {
            return $modal.open({
                template: require('../view/tax-modal-select.html'),
                controller: 'TaxModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return tax;
                    },
                    taxFilters: function() {
                        return filters != null ? filters : [];
                    },
                    def: () => {
                        return {
                            org: def.org,
                        };
                    },
                },
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/tax-modal-create.html'),
                controller: 'TaxModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return {
                            org: (function(def) {
                                if (def != null && def.org != null) {
                                    return def.org;
                                }
                            })(def),
                        };
                    },
                },
            });
        }

        function edit(tax) {
            return $modal.open({
                template: require('../view/tax-modal-create.html'),
                controller: 'TaxModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    tax: function() {
                        return tax;
                    },
                },
            });
        }
    }];
